import { getBatchMoveApi } from './configuration';
import { StbGroup } from '@services/types';
import { MoveStbGroupBatchModeEnum } from '@openapi';

const batchMove = {
  exportBatch: (stbId: StbGroup['id'], file: Blob, mode: MoveStbGroupBatchModeEnum) => {
    return getBatchMoveApi().moveStbGroupBatch({ id: stbId, file: file, mode });
  },
};

export default batchMove;
